import React, { Component } from 'react';
import config from 'config/api';
import { connect } from 'react-redux';
// import Immutable from "immutable";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import getCardImage from 'helpers/getCardImage';
import Hidden from '@material-ui/core/Hidden';
import Paragrapher from 'components/UI/Paragrapher';
import getLiveEvent from 'helpers/getLiveEvent';
// import getMySubscriptions from 'helpers/getMySubscriptions';
import getRemainingTime from 'helpers/getRemainingTime';

import { formatDate } from 'helpers/stringUtils';
// import Box from "@material-ui/core/Box";
import { isLoggedIn, getCurrentUserRole, getCurrentUser, isStateKnown } from 'ducks/authentication';
import {
  fetchData,
  getDataHome,
  // getLoadingError
} from '../../ducks/asyncFetcher';
import Typography from '@material-ui/core/Typography';
import { withRouter } from 'react-router-dom';
import Template from 'components/Template/Template';
// import getRemainingTime from "helpers/getRemainingTime";
// import gotoLiveRoom from "helpers/gotoLiveRoom";
import i18n from 'helpers/i18n';
import getMySubscriptions from 'helpers/getMySubscriptions';
const styles = (theme) => {
  return {
    // wrapper: {
    //   margin: "0 auto 100px",
    //   [theme.breakpoints.up("md")]: {
    //     padding: "0 20px",
    //   },
    //   [theme.breakpoints.up("lg")]: {
    //     padding: "0 100px",
    //   },
    // },
    titlePadder: {
      padding: '20px 10px',
      [theme.breakpoints.down('sm')]: {
        padding: '10px 10px',
      },
      '& .MuiTypography-h1': {
        padding: 0,
        fontSize: '2.8rem',
        [theme.breakpoints.down('sm')]: {
          textAlign: 'center',
          fontSize: '2rem',
          // paddingBottom: 20
        },
        [theme.breakpoints.down('xs')]: {
          textAlign: 'center',
          fontSize: '2rem',
          // paddingBottom: 20
        },
      },
      '& .MuiTypography-h2': {
        [theme.breakpoints.up('sm')]: {
          textAlign: 'left',
        },
        [theme.breakpoints.down('sm')]: {
          textAlign: 'center',
        },
      },
    },
    homeTitles: {
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
      },
    },
    eventGuestImage: {
      // width: '100%',
      // height: 100,
      // backgroundPosition: '50% 50%',
      // backgroundSize: 'cover',
      // backgroundRepeat: 'no-repeat'
      float: 'right',
      width: '100px',
      height: '100px',
      marginRight: 20,
      [theme.breakpoints.down('xs')]: {
        display: 'none',
      },
    },
    // inline: {
    //   display: "inline-block",
    // },
    // emphasis: {
    //   color: theme.palette.secondary.main,
    // },
    // oversizeButton: {
    //   fontSize: "1rem",
    //   padding: 20,
    //   fontWeight: "bold",
    //   color: theme.palette.primary.main,
    //   backgroundColor: "rgba(255, 255, 255, 0.8)",
    //   [theme.breakpoints.down("sm")]: {},
    //   [theme.breakpoints.up("lg")]: {
    //     padding: "20px 50px",
    //     fontSize: "1.2rem",
    //   },
    // },
    // homeButtons: {
    //   [theme.breakpoints.down("sm")]: {
    //     margin: theme.spacing(3) + "px",
    //   },
    //   "& .MuiGrid-item:first-child": {
    //     marginBottom: theme.spacing(4),
    //     [theme.breakpoints.down("sm")]: {
    //       marginBottom: theme.spacing(3),
    //     },
    //   },
    // },
    // top: {
    //   padding: "0 20px",
    //   height: "calc(100% - 200px)",
    //   [theme.breakpoints.down("sm")]: {
    //     height: "auto",
    //   },
    // },
    // bottom: {
    //   height: 200,
    //   backgroundColor: "rgba(255, 255, 255, 0.8)",
    //   padding: "20px 30px",
    //   [theme.breakpoints.down("sm")]: {
    //     height: "auto",
    //   },
    // },
    rowTitle: {
      minHeight: '30vh',
      '& .MuiTypography-h1': {
        color: '#000',
        borderBottom: 'none',
        paddingBottom: 0,
        // marginBottom: 0
      },
      '& .MuiTypography-h2': {
        color: '#000',
      },
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
      },
    },
    // rowPadder: {
    //   padding: '60px 10px',
    //   [theme.breakpoints.down("sm")]: {
    //     padding: '40px 10px'
    //   },
    // },
    row: {
      width: 'calc(100% - 10px)',
      minHeight: '100px',
      marginBottom: '5px',
      margin: '0 0 30px',
      '& .MuiTypography-h5': {
        fontSize: '1.8rem',
        fontWeight: 'bold',
        // color: theme.palette.primary.main,
        textAlign: 'left',
        padding: '0 25px',
        [theme.breakpoints.down('xs')]: {
          textAlign: 'center',
          marginBottom: theme.spacing(2),
          //   padding: '0 20px',
        },
        // [theme.breakpoints.down("sm")]: {
        //   padding: '0 20px',
        // }
      },
      '& .MuiTypography-body1': {
        fontSize: '1.2rem',
        // fontWeight: 'bold',
        textAlign: 'left',
        padding: '0 25px',
        [theme.breakpoints.down('xs')]: {
          textAlign: 'center',
          marginBottom: theme.spacing(2),
          //   padding: '0 20px',
        },
      },
      '& .MuiTypography-body2': {
        fontSize: '1.1rem',
        fontWeight: 'bold',
        [theme.breakpoints.down('xs')]: {
          textAlign: 'center',
          marginBottom: theme.spacing(2),
          //   padding: '0 20px',
        },
      },
      '& .MuiButton-root.MuiButton-containedSecondary': {
        marginTop: 20,
      },
    },
    event: {
      paddingBottom: 30,
    },
    rowCell: {
      textAlign: 'center',
      position: 'relative',
      '& .MuiTypography-subtitle2': {
        color: '#fff',
        margin: '0 auto',
        position: 'relative',
        fontWeight: 'bold',
        fontSize: '1.1rem',
        width: 'calc(100% - 10px)',
        paddingLeft: 5,
        paddingRight: 5,
      },
      '&:before': {
        content: '" "',
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: 'calc(100% - 5px)',
        backgroundColor: theme.palette.primary.light,
        [theme.breakpoints.down('sm')]: {
          width: 'calc(100% - 10px)',
          marginLeft: '5px',
          marginRight: '5px',
        },
      },
      '&:last-of-type:before': {
        width: '100%',
        [theme.breakpoints.down('sm')]: {
          width: 'calc(100% - 10px)',
          marginLeft: '5px',
          marginRight: '5px',
        },
      },
      [theme.breakpoints.down('sm')]: {
        marginBottom: '5px',
        paddingTop: 10,
        paddingBottom: 10,
      },
    },
    spacer: {
      margin: '30px 0 20px',
      height: 5,
      display: 'block',
      position: 'relative',
      width: '100%',
      '&:after': {
        width: 'calc(100% - 40px)',
        content: "' '",
        position: 'absolute',
        height: 5,
        left: 25,
        top: 0,
        backgroundColor: '#babbb9',
      },
      '&:before': {
        content: "' '",
        position: 'absolute',
        width: 20,
        height: 20,
        left: 0,
        top: '-14px',
        backgroundColor: theme.palette.primary.main,
      },
    },
    buttonRegister: {
      marginBottom: 20,
      fontSize: '1.8rem',
      fontWeight: 'bold',
      [theme.breakpoints.down('md')]: {
        fontSize: '1.4rem',
      },
    },
  };
};
class HomeVisitor extends Component {
  constructor(props) {
    super(props);
    this.state = { showLiveButton: false };
  }
  componentDidMount() {
    this.props.onMount();
  }
  componentDidUpdate(oldProps) {
    // console.log(oldProps.$$data.toJS(), oldProps.userRole, this.props.userRole)
    if (
      (oldProps.$$user === undefined && this.props.$$user !== undefined) ||
      (this.props.$$user !== undefined && oldProps.$$data !== this.props.$$data)
    ) {
      // console.log('GOGOGO');
      this._startTimer();
    }
  }
  componentWillUnmount() {
    this._stopTimer();
  }

  _getMyLiveEvent = () => {
    const { $$data, $$user } = this.props;
    const userRole = $$user ? $$user.get('role') : false;

    const $$subscriptions = getMySubscriptions({ userRole, $$data });
    return getLiveEvent({ $$data, $$subscriptions });
  };

  _stopTimer = () => {
    if (this._remainingTimer) {
      clearInterval(this._remainingTimer);
    }
  };
  _startTimer = () => {
    // console.log('test1');
    if (this._remainingTimer) return;
    const $liveEvent = this._getMyLiveEvent();
    // console.log('test2', $liveEvent);
    if ($liveEvent === undefined) return;

    // console.log('starting timer')
    // this._cardTimer = $$card.get('eventDate');
    this._remainingTimer = setInterval(this._runRemainingTimer, 1000);
    this._runRemainingTimer();
  };
  _runRemainingTimer = () => {
    // console.log('run1')
    const $liveEvent = this._getMyLiveEvent();
    if ($liveEvent === undefined) {
      return this._stopTimer();
    }
    // console.log('run');
    const timeRemaining =
      $liveEvent !== undefined
        ? getRemainingTime($liveEvent.get('eventDate'))
        : {
            days: 0,
            hours: 0,
            minutes: 0,
          };
    // console.log(timeRemaining)
    if (timeRemaining.days <= 0 && timeRemaining.hours <= 0 && timeRemaining.minutes <= 5) {
      this.setState(
        {
          showLiveButton: true,
        },
        () => {
          this._stopTimer();
        },
      );
    } else {
      const { showLiveButton } = this.state;
      this.setState({
        timeRemaining,
        showLiveButton: $liveEvent.get('eventState') === 'live',
      });
    }
  };

  render() {
    const { classes, history, $$data, $$user } = this.props;
    const { showLiveButton } = this.state;
    const userRole = $$user ? $$user.get('role') : false;
    const $$subscriptions = getMySubscriptions({
      $$data: $$data,
      userRole,
    });
    let $$groupIdx;
    let $$dateSubcribed;
    let $$subscribedIds;
    return (
      <Template
        title={
          <div className={classes.titlePadder}>
            <Typography variant={'h1'} gutterBottom color="textPrimary">
              {i18n.get('homeTitle')}
            </Typography>
            <Typography variant={'h2'} gutterBottom color="textPrimary">
              {i18n.get('homeSubtitle1')}
            </Typography>
            <If condition={i18n.has('homeSubtitle2')}>
              <Typography variant={'h2'} gutterBottom={i18n.has('homeSubtitle3')} color="textPrimary">
                {i18n.get('homeSubtitle2')}
              </Typography>
            </If>
            <If condition={i18n.has('homeSubtitle3')}>
              <Typography variant={'h2'} color="textPrimary">
                {i18n.get('homeSubtitle3')}
              </Typography>
            </If>
          </div>
        }
      >
        <Grid container justify="center">
          <Grid item xs={12} container justify="center" className={classes.row}>
            <Grid item xs={12} sm={4} container alignItems="center" className={classes.rowCell}>
              <Typography variant={'subtitle2'}>{i18n.get('homeRowText1')}</Typography>
            </Grid>
            <Grid item xs={12} sm={4} container alignItems="center" className={classes.rowCell}>
              <Typography variant={'subtitle2'}>{i18n.get('homeRowText2')}</Typography>
            </Grid>
            <Grid item xs={12} sm={4} container alignItems="center" className={classes.rowCell}>
              <Typography variant={'subtitle2'}>{i18n.get('homeRowText3')}</Typography>
            </Grid>
          </Grid>

          <If condition={$$data !== undefined}>
            {$$data
              .get('availableEvents')
              .groupBy(($$g) => $$g.get('eventInternalReference'))
              .map(($$group, gIdx) => {
                $$groupIdx = $$group.map(($$g) => $$g.get('id'));
                $$subscribedIds = $$subscriptions.filter(($$s) => $$groupIdx.contains($$s));
                $$dateSubcribed = $$group
                  .filter(($$g) => $$subscribedIds.contains($$g.get('id')))
                  .sortBy(($$e) => $$e.get('eventDate'))
                  .sortBy(($$e) => $$e.get('eventDate'));
                const $$event = $$dateSubcribed.size > 0 ? $$dateSubcribed.get(0) : $$group.get(0);
                const cardImage = getCardImage($$event) || '';
                return (
                  <Grid
                    key={'g_' + gIdx}
                    item
                    xs={12}
                    container
                    align="center"
                    justify="center"
                    className={clsx(classes.row, classes.event)}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={8}
                      md={
                        $$user === undefined || ($$user !== undefined && $$user.get('role') !== 'speaker')
                          ? 6
                          : 9
                      }
                    >
                      <span className={classes.spacer}></span>
                      <Typography variant={'h5'} gutterBottom>
                        {$$event.get('eventTitle')}
                      </Typography>
                      <Typography variant={'body1'}>
                        <Paragrapher
                          text={$$event.get('eventDescription')}
                          prettyfy={true}
                          element="span"
                          elementStyle={{ display: 'block' }}
                        />
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4} md={3}>
                      <Hidden xsDown>
                        <span className={classes.spacer}></span>
                      </Hidden>
                      <If condition={cardImage !== false && cardImage !== undefined && cardImage !== null}>
                        <Avatar src={cardImage} className={classes.eventGuestImage}></Avatar>
                      </If>

                      <Typography variant="body2" color="primary" align="left">
                        {i18n.get('homeEventSubscribeAnimatedBy')}
                      </Typography>
                      <Typography variant="body2" color="primary" align="left">
                        <Paragrapher
                          text={$$event.get('eventGuests')}
                          element="span"
                          prettyfy={true}
                          elementStyle={{ display: 'block' }}
                        />
                      </Typography>
                      {/* <Box className={classes.eventGuestImage} style={{backgroundImage: 'url('+cardImage+')'}}></Box> */}
                    </Grid>
                    <If
                      condition={
                        $$user === undefined || ($$user !== undefined && $$user.get('role') !== 'speaker')
                      }
                    >
                      <Grid item xs={12} sm={12} md={3} align="center">
                        <Hidden smDown>
                          <span className={classes.spacer}></span>
                        </Hidden>

                        <If condition={$$dateSubcribed.size >= 1}>
                          <If condition={$$event.get('eventState') === 'live' && showLiveButton === true}>
                            <Typography variant="body1" gutterBottom style={{ textAlign: 'center' }}>
                              {i18n.get('cardAlreadyStarted', { element: 'span' })}
                            </Typography>

                            <Button
                              size="large"
                              color="secondary"
                              variant="contained"
                              className={classes.buttonRegister}
                              onClick={(e) => {
                                e.preventDefault();
                                history.push('/live/' + $$event.get('id'));
                              }}
                            >
                              {i18n.get('cardLiveBtn')}
                            </Button>
                          </If>
                          <If condition={$$event.get('eventState') === 'pending' }>
                            <Typography variant="body1" gutterBottom style={{ textAlign: 'center' }}>
                              <small>Vous êtes inscrit à la webconférence du </small>
                              <br />
                              {formatDate($$dateSubcribed.get(0).get('eventDate'), 'dddd dd mmmm yyyy') +
                                ' - ' +
                                formatDate($$dateSubcribed.get(0).get('eventDate'), "HH'h'MM")}
                            </Typography>

                            <Button
                              size="large"
                              color="secondary"
                              variant="contained"
                              className={classes.buttonRegister}
                              onClick={(e) => {
                                e.preventDefault();
                                history.push('/subscribe/' + $$event.get('eventInternalReference'));
                              }}
                            >
                              {i18n.get('homeEventModifyBt')}
                            </Button>
                          </If>
                        </If>
                        <If condition={$$dateSubcribed.size === 0}>
                          <Button
                            size="large"
                            color="secondary"
                            variant="contained"
                            className={classes.buttonRegister}
                            onClick={(e) => {
                              e.preventDefault();
                              history.push('/subscribe/' + $$event.get('eventInternalReference'));
                            }}
                          >
                            {i18n.get('homeEventSubscribeBt')}
                          </Button>
                        </If>
                        <If condition={userRole === false || userRole === 'visitor'}>
                          <Typography variant="caption">{i18n.get('homeEventSubscribeCaption')}</Typography>
                        </If>
                      </Grid>
                    </If>
                  </Grid>
                );
              })
              .toArray()}
          </If>
        </Grid>
      </Template>
    );
  }
}
// export default withRouter(withStyles(styles)(HomeVisitor));
function mapStateToProps(state) {
  const props = {
    $$data: getDataHome(state),
    // error: getLoadingError(state),
    isLoggedIn: isLoggedIn(state),
    userRole: getCurrentUserRole(state),
    authStateKnown: isStateKnown(state),
    $$user: getCurrentUser(state),
  };
  return props;
}

function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {
      dispatch(
        fetchData({
          key: 'home',
          fetchUrl: config.home,
        }),
      );
    },
  };
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(HomeVisitor)));



// WEBPACK FOOTER //
// ./src/components/Home/HomeVisitor.jsx